import '../../stylesheets/skeletons/chartskeletons.css';

const ChartsSkeleton = () => {
    return (
        <div className="skeleton-container">
            <div className="skeleton-grid">
                {/* Card 1 */}
                <div className="skeleton-card">
                    <div className="skeleton-card-header">
                        <div className="skeleton-title"></div>
                        <div className="skeleton-subtitle"></div>
                    </div>
                    <div className="skeleton-chart">
                        <div className="skeleton-bar" style={{ height: '40%' }}></div>
                        <div className="skeleton-bar" style={{ height: '60%' }}></div>
                        <div className="skeleton-bar" style={{ height: '80%' }}></div>
                        <div className="skeleton-bar" style={{ height: '50%' }}></div>
                    </div>
                </div>

                {/* Card 2 */}
                <div className="skeleton-card">
                    <div className="skeleton-card-header">
                        <div className="skeleton-title"></div>
                        <div className="skeleton-subtitle"></div>
                    </div>
                    <div className="skeleton-chart">
                        <div className="skeleton-bar" style={{ height: '70%' }}></div>
                        <div className="skeleton-bar" style={{ height: '45%' }}></div>
                        <div className="skeleton-bar" style={{ height: '90%' }}></div>
                        <div className="skeleton-bar" style={{ height: '35%' }}></div>
                    </div>
                </div>

                {/* Card 3 */}
                <div className="skeleton-card">
                    <div className="skeleton-card-header">
                        <div className="skeleton-title"></div>
                        <div className="skeleton-subtitle"></div>
                    </div>
                    <div className="skeleton-chart">
                        <div className="skeleton-bar" style={{ height: '55%' }}></div>
                        <div className="skeleton-bar" style={{ height: '75%' }}></div>
                        <div className="skeleton-bar" style={{ height: '40%' }}></div>
                        <div className="skeleton-bar" style={{ height: '65%' }}></div>
                    </div>
                </div>

                {/* Card 4 */}
                <div className="skeleton-card">
                    <div className="skeleton-card-header">
                        <div className="skeleton-title"></div>
                        <div className="skeleton-subtitle"></div>
                    </div>
                    <div className="skeleton-chart">
                        <div className="skeleton-bar" style={{ height: '50%' }}></div>
                        <div className="skeleton-bar" style={{ height: '85%' }}></div>
                        <div className="skeleton-bar" style={{ height: '60%' }}></div>
                        <div className="skeleton-bar" style={{ height: '70%' }}></div>
                    </div>
                </div>

                {/* Card 5 */}
                <div className="skeleton-card">
                    <div className="skeleton-card-header">
                        <div className="skeleton-title"></div>
                        <div className="skeleton-subtitle"></div>
                    </div>
                    <div className="skeleton-chart">
                        <div className="skeleton-bar" style={{ height: '65%' }}></div>
                        <div className="skeleton-bar" style={{ height: '40%' }}></div>
                        <div className="skeleton-bar" style={{ height: '80%' }}></div>
                        <div className="skeleton-bar" style={{ height: '55%' }}></div>
                    </div>
                </div>

                {/* Card 6 */}
                <div className="skeleton-card">
                    <div className="skeleton-card-header">
                        <div className="skeleton-title"></div>
                        <div className="skeleton-subtitle"></div>
                    </div>
                    <div className="skeleton-chart">
                        <div className="skeleton-bar" style={{ height: '75%' }}></div>
                        <div className="skeleton-bar" style={{ height: '50%' }}></div>
                        <div className="skeleton-bar" style={{ height: '90%' }}></div>
                        <div className="skeleton-bar" style={{ height: '45%' }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChartsSkeleton;
